export default function DeltaAVisual() {
  return <div>Delta A works</div>;
}